/** The outline over the drawn instance a second click selected (`OVL-026`). */

import type { StageSelection } from "./SpaceCanvas";

/** Drawn in canvas fractions, which is the one unit the stage reports a pick in. */
export function NodeOutline({ selection }: { readonly selection: StageSelection | null }) {
  const bounds = selection?.bounds;
  if (selection === undefined || selection === null || bounds === undefined) return null;

  return (
    <div
      className="cx-node-outline"
      aria-hidden="true"
      style={{
        left: `${String(bounds.x * 100)}%`,
        top: `${String(bounds.y * 100)}%`,
        width: `${String(bounds.width * 100)}%`,
        height: `${String(bounds.height * 100)}%`,
      }}
    >
      <span className="cx-node-outline-name">{selection.nodeId ?? ""}</span>
    </div>
  );
}
